"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    culture: String,
    dates: Array,
    depth: String,
    disableDates: Array | Function,
    footer: String | Function,
    format: String,
    max: Date,
    messages: Object,
    min: Date,
    month: Object,
    views: Number,
    range: Object,
    selectable: String,
    selectDates: Array,
    showViewHeader: Boolean,
    weekNumber: Boolean,
    start: String,
    value: Date,

    // Events
    change: Function,
    navigate: Function
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-dateinputs-vue-wrapper/dist/es/KendoMultiViewCalendar/MultiViewCalendarProps.js
// module id = 726
// module chunks = 0